import { render, staticRenderFns } from "./informacoes-manutencao.vue?vue&type=template&id=09361765"
import script from "./informacoes-manutencao.vue?vue&type=script&lang=js"
export * from "./informacoes-manutencao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports